<div class="ruckit-driver-reference-cell">
  <driver-reference-selector
    #driverReferences
    (referenceSelected)="onReferenceClicked($event)"
    (onClose)="onReferenceClosed()"
  ></driver-reference-selector>
</div>
